import { render } from "./PartnerTable.vue?vue&type=template&id=0a74b59f&scoped=true"
import script from "./PartnerTable.vue?vue&type=script&lang=js"
export * from "./PartnerTable.vue?vue&type=script&lang=js"

import "./PartnerTable.vue?vue&type=style&index=0&id=0a74b59f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a74b59f"]])

export default __exports__